export const IDP_ID_MAX_LENGTH: number = 36;
